/**
 * Component for populating protected button (controlled by user role).
 */

import React, { memo } from 'react';
import { useSelector } from 'react-redux';
import { Button } from 'antd';
import { isEmpty, includes } from 'lodash';

import { getUserCompanyRole } from '../../store/companies/sagas';

interface IProps {
    buttonProps: {};
    allowedRoles?: string[];
    children: any;
}
const ProtectedButton: React.FC<IProps> = (props: IProps) => {
    const userRole = useSelector(getUserCompanyRole);

    return isEmpty(props.allowedRoles) ||
        includes(props.allowedRoles, userRole) ? (
        <Button {...props.buttonProps}>{props.children}</Button>
    ) : null;
};

export default memo(ProtectedButton);
